import { Component, Signal } from '@angular/core'
import { MessageComponent } from '../message/message.component'
import { ToastService } from '@services/toast/toast.service'
import { IToast } from '@interfaces/i-toast'
import { InlineTranslationDirective } from '@directives/inline-translation/inline-translation.directive'

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [MessageComponent, InlineTranslationDirective],
  standalone: true,
})

export class ToastComponent {
  toasts: Signal<IToast[]> = this.toastService.toasts

  constructor(private readonly toastService: ToastService) {}

  dismiss(index: number) {
    this.toastService.dismiss(index)
  }

}